<tilby-dialog-toolbar mat-dialog-title
    [title]="title"
    [hideConfirm]="true"
/>
<tilby-dialog-content>
    <div class="tw-mb-3">
        <span>{{message}}</span>
    </div>
</tilby-dialog-content>